import { evaluatePasswordPolicy } from './passwordPolicy'
import {
  formatIsoToDdMmYyyy,
  normalizeIsoDateString,
  parseDdMmYyyyToIso,
  todayIsoLocal,
} from './portalDateFormat'

const rules = {
  observacionesTurno: (v) => {
    const text = String(v ?? '')
    return text.trim() === '' || text.length <= 100 || 'Las observaciones no pueden superar los 100 caracteres.'
  },
  required: (v) =>
    (v !== null && v !== undefined && String(v).trim() !== '') || 'Campo obligatorio',
  email: (v) => {
    const s = String(v ?? '').trim()
    if (s === '') return true
    const re = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/i
    return re.test(s) || 'Ingrese un correo electrónico válido'
  },
  /** Regla Vuetify: (v) => ... — debe coincidir con el valor de la otra contraseña. */
  sameAs: (otherValue) => (v) => {
    const a = String(v ?? '')
    const b = String(otherValue ?? '')
    if (a === '' && b === '') return true
    return a === b || 'Las contraseñas no coinciden'
  },
  passwordPolicy: (v) => {
    const s = String(v ?? '')
    if (s === '') return true
    const p = evaluatePasswordPolicy(s)
    return p.allMet || 'La contraseña no cumple los requisitos indicados.'
  },
  matchPassword: (value, password) =>
    value === password || 'Las contraseñas no coinciden',
  maxLength: (limit) => (v) => {
    if (v == null || v === '') return true
    return String(v).length <= limit || `Máximo ${limit} caracteres`
  },
  /** Texto en DD/MM/AAAA; vacío válido */
  validDdMmYyyy: (v) => {
    const s = String(v ?? '').trim()
    if (s === '') return true
    if (!/^\d{1,2}\/\d{1,2}\/\d{4}$/.test(s)) return 'Use el formato DD/MM/AAAA'
    return parseDdMmYyyyToIso(s) ? true : 'Fecha no válida'
  },
  /** Fecha en DD/MM/AAAA no posterior a hoy (comparación en ISO local). */
  dateDdMmNotAfterToday: (v) => {
    const s = String(v ?? '').trim()
    if (s === '') return true
    const iso = parseDdMmYyyyToIso(s)
    if (!iso) return true
    return iso <= todayIsoLocal() || 'La fecha no puede ser posterior a hoy'
  },
  /** Fecha en DD/MM/AAAA no anterior a `minIso` (YYYY-MM-DD). */
  dateDdMmNotBeforeMinIso: (minIso) => (v) => {
    const min = normalizeIsoDateString(minIso)
    if (!min) return true
    const s = String(v ?? '').trim()
    if (s === '') return true
    const iso = parseDdMmYyyyToIso(s)
    if (!iso) return true
    if (iso >= min) return true
    const label = formatIsoToDdMmYyyy(min)
    return `La fecha no puede ser anterior al ${label || min}`
  },
  dateDdMmNotAfterMaxIso: (maxIso) => (v) => {
    const max = normalizeIsoDateString(maxIso)
    if (!max) return true
    const s = String(v ?? '').trim()
    if (s === '') return true
    const iso = parseDdMmYyyyToIso(s)
    if (!iso) return true
    if (iso <= max) return true
    const label = formatIsoToDdMmYyyy(max)
    return `La fecha no puede ser posterior al ${label || max}`
  },
}

export default rules
